import moment from 'moment';
import React from 'react';

import * as constants from '../constants';

const useCalendarBounds = selectedDateString => {
  const [calendarBounds, setCalendarBounds] = React.useState({
    month: getMonthStartAndEnd(selectedDateString),
    week: getWorkWeekStartAndEnd(selectedDateString)
  });

  React.useEffect(
    () => {
      setCalendarBounds({
        month: getMonthStartAndEnd(selectedDateString),
        week: getWorkWeekStartAndEnd(selectedDateString)
      });
    },
    [selectedDateString]
  );

  return calendarBounds;
};

const getMonthStartAndEnd = dateString => {
  const selectedDateMoment = moment(dateString, constants.calendar.DATE_FORMAT);
  return {
    startTime: selectedDateMoment.clone().startOf('month').valueOf(),
    endTime: selectedDateMoment.clone().endOf('month').valueOf()
  };
};

const getWorkWeekStartAndEnd = dateString => {
  const selectedDateMoment = moment(dateString, constants.calendar.DATE_FORMAT);
  return {
    startTime: selectedDateMoment
      .clone()
      .startOf('week')
      .valueOf(),
    endTime: selectedDateMoment
      .clone()
      .endOf('week')
      .valueOf()
  };
};

export default useCalendarBounds;